import { render } from "./MenuDemo.vue?vue&type=template&id=20820760"
import script from "./MenuDemo.vue?vue&type=script&lang=js"
export * from "./MenuDemo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\prathamesh\\mahajyoti_admin_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__